import React, { useState, useEffect } from 'react';
import './App.css';

function App() {
  const [showCookieConsent, setShowCookieConsent] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    telefono: '',
    mensaje: '',
    servicio: 'consultoria'
  });

  useEffect(() => {
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      setShowCookieConsent(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookieConsent', 'true');
    setShowCookieConsent(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { nombre, email, telefono, mensaje, servicio } = formData;
    const subject = `Consulta de ${servicio} - ${nombre}`;
    const body = `Nombre: ${nombre}%0D%0AEmail: ${email}%0D%0ATeléfono: ${telefono}%0D%0AServicio: ${servicio}%0D%0A%0D%0AMensaje:%0D%0A${mensaje}`;
    window.location.href = `mailto:info@mx-documentos.com?subject=${encodeURIComponent(subject)}&body=${body}`;
  };

  const openModal = (content) => {
    setModalContent(content);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setModalContent('');
  };

  return (
    <div className="app">
      {/* Header/Navigation */}
      <nav className="nav-container">
        <div className="container mx-auto flex justify-between items-center px-6 py-4">
          <div className="logo-section">
            <h1 className="text-2xl font-bold text-white">MX-DOCUMENTOS</h1>
            <p className="text-sm text-blue-200">Consultoría de Documentos para México</p>
          </div>
          <div className="nav-links hidden md:flex space-x-6">
            <a href="#servicios" className="text-white hover:text-blue-200 transition">Servicios</a>
            <a href="#sobre-nosotros" className="text-white hover:text-blue-200 transition">Nosotros</a>
            <a href="#contacto" className="text-white hover:text-blue-200 transition">Contacto</a>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-overlay">
          <div className="container mx-auto px-6 text-center">
            <h1 className="hero-title text-5xl md:text-7xl font-bold text-white mb-6">
              Su Camino a México Comienza Aquí
            </h1>
            <p className="hero-subtitle text-xl md:text-2xl text-white mb-8 max-w-3xl mx-auto">
              Asesoría profesional para trámites de documentos mexicanos con más de 10 años de experiencia
            </p>
            <a href="#contacto" className="cta-button">
              Comenzar Ahora
            </a>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="servicios" className="section-padding bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="section-title">Nuestros Servicios</h2>
            <p className="section-subtitle">Soluciones completas para su trámite de documentos mexicanos</p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
            {/* Service 1 */}
            <div className="service-card">
              <div className="service-icon">📋</div>
              <h3 className="service-title">Consultoría de Documentos</h3>
              <p className="service-price">GRATIS</p>
              <p className="service-description">
                Evaluación inicial de sus necesidades y análisis completo de su elegibilidad para obtener documentos mexicanos.
              </p>
              <ul className="service-features">
                <li>✓ Evaluación de elegibilidad</li>
                <li>✓ Revisión de requisitos</li>
                <li>✓ Asesoría personalizada</li>
                <li>✓ Sin compromiso</li>
              </ul>
            </div>

            {/* Service 2 */}
            <div className="service-card featured">
              <div className="featured-badge">Más Popular</div>
              <div className="service-icon">📑</div>
              <h3 className="service-title">Recopilación de Documentos</h3>
              <p className="service-price">$100 USD</p>
              <p className="service-description">
                Asistencia completa para reunir, preparar y presentar todos los documentos necesarios para su solicitud.
              </p>
              <ul className="service-features">
                <li>✓ Recopilación completa de documentos</li>
                <li>✓ Verificación de autenticidad</li>
                <li>✓ Preparación de formularios</li>
                <li>✓ Presentación ante autoridades</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="sobre-nosotros" className="section-padding bg-gradient">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center text-white">
            <h2 className="section-title text-white mb-8">¿Por Qué Elegirnos?</h2>
            <div className="grid md:grid-cols-3 gap-8 mt-12">
              <div className="feature-box">
                <div className="feature-number">10+</div>
                <h3 className="font-semibold text-xl mb-2">Años de Experiencia</h3>
                <p>Especializados en trámites de documentos mexicanos</p>
              </div>
              <div className="feature-box">
                <div className="feature-number">98%</div>
                <h3 className="font-semibold text-xl mb-2">Tasa de Éxito</h3>
                <p>Aprobaciones exitosas en solicitudes</p>
              </div>
              <div className="feature-box">
                <div className="feature-number">24/7</div>
                <h3 className="font-semibold text-xl mb-2">Soporte</h3>
                <p>Atención al cliente siempre disponible</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section id="contacto" className="section-padding bg-white">
        <div className="container mx-auto px-6">
          <div className="max-w-3xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="section-title">Contáctenos</h2>
              <p className="section-subtitle">Déjenos sus datos y nos pondremos en contacto con usted</p>
            </div>

            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="nombre" className="form-label">Nombre Completo *</label>
                  <input
                    type="text"
                    id="nombre"
                    name="nombre"
                    required
                    value={formData.nombre}
                    onChange={handleInputChange}
                    className="form-input"
                    placeholder="Su nombre completo"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email" className="form-label">Correo Electrónico *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    value={formData.email}
                    onChange={handleInputChange}
                    className="form-input"
                    placeholder="su@email.com"
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="telefono" className="form-label">Teléfono</label>
                  <input
                    type="tel"
                    id="telefono"
                    name="telefono"
                    value={formData.telefono}
                    onChange={handleInputChange}
                    className="form-input"
                    placeholder="+1 234 567 8900"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="servicio" className="form-label">Servicio de Interés *</label>
                  <select
                    id="servicio"
                    name="servicio"
                    required
                    value={formData.servicio}
                    onChange={handleInputChange}
                    className="form-input"
                  >
                    <option value="consultoria">Consultoría de Documentos (Gratis)</option>
                    <option value="recopilacion">Recopilación de Documentos ($100)</option>
                  </select>
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="mensaje" className="form-label">Mensaje *</label>
                <textarea
                  id="mensaje"
                  name="mensaje"
                  required
                  rows="5"
                  value={formData.mensaje}
                  onChange={handleInputChange}
                  className="form-input"
                  placeholder="Cuéntenos sobre su situación..."
                ></textarea>
              </div>

              <button type="submit" className="submit-button">
                Enviar Consulta
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-3 gap-8 mb-8">
            <div>
              <h3 className="font-bold text-xl mb-4">INTELLIGENCE LTD</h3>
              <p className="text-gray-400 mb-2">Número de registro: 14304138</p>
              <p className="text-gray-400 mb-2">Incorporada: 18 de agosto de 2022</p>
            </div>
            <div>
              <h3 className="font-bold text-xl mb-4">Contacto</h3>
              <p className="text-gray-400 mb-2">📧 info@mx-documentos.com</p>
              <p className="text-gray-400 mb-2">🌐 https://mx-documentos.com</p>
              <p className="text-gray-400">📍 257a Whitechapel Road, London, England, E1 1DB</p>
            </div>
            <div>
              <h3 className="font-bold text-xl mb-4">Legal</h3>
              <button onClick={() => openModal('terms')} className="text-gray-400 hover:text-white block mb-2">
                Términos y Condiciones
              </button>
              <button onClick={() => openModal('privacy')} className="text-gray-400 hover:text-white block">
                Política de Privacidad
              </button>
            </div>
          </div>
          <div className="border-t border-gray-700 pt-6 text-center text-gray-400">
            <p>© 2024 INTELLIGENCE LTD. Todos los derechos reservados.</p>
          </div>
        </div>
      </footer>

      {/* Cookie Consent Banner */}
      {showCookieConsent && (
        <div className="cookie-banner">
          <div className="container mx-auto px-6 flex flex-col md:flex-row items-center justify-between">
            <p className="text-white mb-4 md:mb-0 md:mr-4">
              🍪 Este sitio web utiliza cookies para mejorar su experiencia. Al continuar navegando, acepta nuestro uso de cookies.
            </p>
            <button onClick={acceptCookies} className="cookie-accept-btn">
              Aceptar
            </button>
          </div>
        </div>
      )}

      {/* Modal for Terms & Privacy */}
      {showModal && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>&times;</button>
            <div className="modal-body">
              {modalContent === 'terms' ? (
                <div>
                  <h2 className="text-3xl font-bold mb-6">Términos y Condiciones</h2>
                  <div className="space-y-4 text-gray-700">
                    <p><strong>Última actualización: Noviembre 2024</strong></p>
                    
                    <h3 className="text-xl font-semibold mt-6">1. Aceptación de los Términos</h3>
                    <p>Al acceder y utilizar los servicios de INTELLIGENCE LTD, usted acepta estar sujeto a estos términos y condiciones.</p>
                    
                    <h3 className="text-xl font-semibold mt-6">2. Servicios Ofrecidos</h3>
                    <p>INTELLIGENCE LTD ofrece servicios de consultoría y asistencia en la preparación de documentos para trámites mexicanos. No garantizamos la aprobación de ninguna solicitud.</p>
                    
                    <h3 className="text-xl font-semibold mt-6">3. Responsabilidades del Cliente</h3>
                    <p>El cliente es responsable de proporcionar información veraz y completa. Cualquier información falsa o incompleta puede resultar en la negación de servicios.</p>
                    
                    <h3 className="text-xl font-semibold mt-6">4. Pagos y Reembolsos</h3>
                    <p>La consultoría de documentos es gratuita. El servicio de recopilación de documentos tiene un costo de $100 USD. Los pagos son no reembolsables una vez iniciado el servicio.</p>
                    
                    <h3 className="text-xl font-semibold mt-6">5. Confidencialidad</h3>
                    <p>Toda la información proporcionada por el cliente será tratada con estricta confidencialidad de acuerdo con nuestra Política de Privacidad.</p>
                    
                    <h3 className="text-xl font-semibold mt-6">6. Limitación de Responsabilidad</h3>
                    <p>INTELLIGENCE LTD no se hace responsable de decisiones tomadas por las autoridades. Nuestro servicio es de asistencia y consultoría únicamente.</p>
                    
                    <h3 className="text-xl font-semibold mt-6">7. Modificaciones</h3>
                    <p>Nos reservamos el derecho de modificar estos términos en cualquier momento. Los cambios entrarán en vigor inmediatamente después de su publicación.</p>
                    
                    <h3 className="text-xl font-semibold mt-6">8. Contacto</h3>
                    <p>Para preguntas sobre estos términos, contacte: info@mx-documentos.com</p>
                  </div>
                </div>
              ) : (
                <div>
                  <h2 className="text-3xl font-bold mb-6">Política de Privacidad</h2>
                  <div className="space-y-4 text-gray-700">
                    <p><strong>Última actualización: Noviembre 2024</strong></p>
                    
                    <h3 className="text-xl font-semibold mt-6">1. Información que Recopilamos</h3>
                    <p>Recopilamos información personal que usted nos proporciona directamente, incluyendo: nombre, correo electrónico, número de teléfono, y cualquier información adicional necesaria para procesar su solicitud.</p>
                    
                    <h3 className="text-xl font-semibold mt-6">2. Uso de la Información</h3>
                    <p>Utilizamos su información personal para:</p>
                    <ul className="list-disc pl-6 space-y-2">
                      <li>Proporcionar nuestros servicios de consultoría</li>
                      <li>Comunicarnos con usted sobre su solicitud</li>
                      <li>Mejorar nuestros servicios</li>
                      <li>Cumplir con obligaciones legales</li>
                    </ul>
                    
                    <h3 className="text-xl font-semibold mt-6">3. Protección de Datos</h3>
                    <p>Implementamos medidas de seguridad técnicas y organizativas para proteger su información personal contra acceso no autorizado, alteración, divulgación o destrucción.</p>
                    
                    <h3 className="text-xl font-semibold mt-6">4. Compartir Información</h3>
                    <p>No vendemos, comercializamos ni transferimos su información personal a terceros, excepto cuando sea necesario para proporcionar nuestros servicios o cuando la ley lo requiera.</p>
                    
                    <h3 className="text-xl font-semibold mt-6">5. Cookies</h3>
                    <p>Utilizamos cookies para mejorar su experiencia en nuestro sitio web. Las cookies son pequeños archivos que se almacenan en su dispositivo. Puede configurar su navegador para rechazar cookies.</p>
                    
                    <h3 className="text-xl font-semibold mt-6">6. Sus Derechos</h3>
                    <p>Usted tiene derecho a:</p>
                    <ul className="list-disc pl-6 space-y-2">
                      <li>Acceder a su información personal</li>
                      <li>Corregir información inexacta</li>
                      <li>Solicitar la eliminación de su información</li>
                      <li>Oponerse al procesamiento de su información</li>
                    </ul>
                    
                    <h3 className="text-xl font-semibold mt-6">7. Retención de Datos</h3>
                    <p>Conservamos su información personal solo durante el tiempo necesario para los fines establecidos en esta política o según lo requiera la ley.</p>
                    
                    <h3 className="text-xl font-semibold mt-6">8. Cambios a esta Política</h3>
                    <p>Podemos actualizar esta política de privacidad periódicamente. Le notificaremos sobre cambios significativos publicando la nueva política en esta página.</p>
                    
                    <h3 className="text-xl font-semibold mt-6">9. Contacto</h3>
                    <p>Para ejercer sus derechos o hacer preguntas sobre esta política, contacte:</p>
                    <p>INTELLIGENCE LTD<br/>
                    257a Whitechapel Road, London, England, E1 1DB<br/>
                    Email: info@mx-documentos.com</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;